import snehDesai from "../assets/coach-sneh-desai.webp";
import vishalMalkan from "../assets/coach-vishal-malkan.webp";
import shivangiDesai from "../assets/coach-shivangi-desai.webp";
import nageshwarShukla from "../assets/coach-nageshwar-shukla.webp";
import devenPandey from "../assets/coach-deven-pandey.webp";
import naveenDhan from "../assets/coach-naveen-dhan.webp";
import viralSakhiya from "../assets/coach-viral-sakhiya.webp";
import meghnaMalkan from "../assets/coach-meghna-malkan.webp";
import purushottamHambarde from "../assets/coach-purushottam-hambarde.webp";
import anjumYasmin from "../assets/coach-anjum-yasmin.webp";
import sadhanGulati from "../assets/coach-sadhan-gulati.webp";
import divasGupta from "../assets/coach-divas-gupta.webp";

const COACHES = [
  { tag: "#1 Business & Life Coach", name: "Sneh Desai", photo: snehDesai },
  { tag: "#1 Stock Trading Coach", name: "Vishal Malkan", photo: vishalMalkan },
  { tag: "#1 Health Coach", name: "Shivangi Desai", photo: shivangiDesai },
  { tag: "#1 Finance Coach", name: "Deven Pandey", photo: devenPandey },
  { tag: "#1 AI Coach", name: "Viral Sakhiya", photo: viralSakhiya },
  { tag: "#1 Cyber Security Coach", name: "Naveen Dhan", photo: naveenDhan, pos: "18% center" },
  { tag: "#1 Sales Mastery Coach", name: "Nageshwar Shukla", photo: nageshwarShukla },
  { tag: "#1 Wealth Mindset Coach", name: "Meghna Malkan", photo: meghnaMalkan },
  { tag: "#1 Digital Coach", name: "Purushottam Hambarde", photo: purushottamHambarde },
  { tag: "#1 Ayurvedic Coach", name: "Anjum Yasmin", photo: anjumYasmin },
  { tag: "#1 Occult Coach", name: "Sadhan Gulati", photo: sadhanGulati },
  { tag: "#1 Public Speaking Coach", name: "Divas Gupta", photo: divasGupta },
];

const Card = ({ c, index }) => (
  <div
    data-testid={`coach-card-${index}`}
    className="group relative aspect-[9/16] rounded-2xl overflow-hidden border border-white/8 w-[calc(50%-8px)] md:w-[calc(25%-15px)]"
    style={{
      background:
        "radial-gradient(120% 100% at 50% 0%, rgba(212,175,55,0.14) 0%, transparent 55%), linear-gradient(180deg, #141414 0%, #0a0a0a 100%)",
      boxShadow:
        "0 30px 60px -28px rgba(10,10,10,0.5), 0 0 0 1px rgba(255,255,255,0.03) inset",
    }}
  >
    {c.photo ? (
      <>
        <img
          src={c.photo}
          alt={c.name}
          data-testid={`coach-photo-${index}`}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
          style={{ objectPosition: c.pos || "center top" }}
        />
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, rgba(10,10,10,0.10) 0%, transparent 35%, rgba(10,10,10,0.55) 72%, rgba(10,10,10,0.92) 100%)",
          }}
        />
      </>
    ) : (
      <div
        aria-hidden
        className="absolute inset-0 opacity-30 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(rgba(255,255,255,0.06) 1px, transparent 1px)",
          backgroundSize: "18px 18px",
        }}
      />
    )}
    <span
      className="absolute top-3 right-3 inline-flex items-center justify-center rounded-full px-2 py-0.5 text-[10px] tracking-wider text-white/60"
      style={{
        background: "rgba(255,255,255,0.05)",
        border: "1px solid rgba(255,255,255,0.10)",
      }}
    >
      {String(index + 1).padStart(2, "0")}
    </span>

    <div className="absolute inset-x-4 bottom-4">
      <div
        className="text-[10px] tracking-[0.18em] uppercase font-medium mb-2"
        style={{ color: "#e6c96b" }}
      >
        {c.tag}
      </div>
      <div className="text-white text-[17px] md:text-[19px] font-semibold tracking-tight leading-tight">
        {c.name}
      </div>
      {!c.photo && (
        <div className="mt-3 flex items-center gap-1.5 text-white/40 text-[10.5px] tracking-widest uppercase">
          <span className="w-3 h-px bg-white/25" />
          Photo coming
        </div>
      )}
    </div>
  </div>
);

export default function FeaturedCoaches() {
  return (
    <section
      data-testid="coaches-section"
      className="relative py-16 md:py-24 border-t border-[#e5e2d8]"
    >
      <div className="mx-auto max-w-[1200px] px-5 md:px-8">
        <div className="text-center mb-12 md:mb-16 max-w-3xl mx-auto">
          <span className="eyebrow" data-testid="coaches-eyebrow">
            <span className="eyebrow-dot" />
            Featured coaches
          </span>
          <h2 className="mt-6 font-semibold tracking-tight text-3xl md:text-5xl lg:text-6xl leading-[1.05]">
            <span className="text-gradient">The category leaders</span>{" "}
            <span className="text-gradient-dim">we&apos;ve scaled.</span>
          </h2>
        </div>

        {/* Flex grid — 4 per row on desktop; last row centers if not full */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-5">
          {COACHES.map((c, i) => (
            <Card key={c.name} c={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
